import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export const inputCls = "w-full bg-[#1B1B28] border hairline px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400/60";
export const labelCls = "block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-2";
export const primaryBtn = "w-full flex items-center justify-center gap-2 bg-cyan-400 hover:bg-cyan-300 text-[#15151F] font-bold text-sm py-3 tracking-wide disabled:opacity-50 transition-colors duration-150";
export const errText = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg).join(" ");
  return fallback;
};

export default function AuthShell({ kicker = "Secure Access", title, sub, children, testid }) {
  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex relative border-r hairline overflow-hidden bg-[#191926]">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/[0.05] via-transparent to-red-500/[0.03]" />
        <div className="relative z-10 p-12 flex flex-col justify-between w-full">
          <Link to="/" className="flex items-center"><Logo size={44} sub="Unified AI Security · v1" id="auth" /></Link>
          <div>
            <div className="font-display text-4xl font-extrabold tracking-tight leading-tight">One agent. <span className="text-cyan-300">Every</span> endpoint.<br />Zero blind spots.</div>
            <p className="text-zinc-400 mt-4 max-w-md">AutoDiscover picks up every Windows endpoint, mailbox and identity. The AI SOC Analyst correlates weak signals into meaningful incidents — with MITRE ATT&CK mapping.</p>
            <div className="mt-8 grid grid-cols-3 gap-4 font-mono text-[10px] uppercase tracking-widest text-zinc-500">
              <div className="border hairline p-3"><div className="text-cyan-300 text-lg font-bold">XDR</div>Endpoint · Email · Identity</div>
              <div className="border hairline p-3"><div className="text-cyan-300 text-lg font-bold">AI</div>Claude Sonnet 5</div>
              <div className="border hairline p-3"><div className="text-cyan-300 text-lg font-bold">$15+</div>Per endpoint / year</div>
            </div>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-600">© 2026 CyboScan · TLS 1.3 · SOC 2 aligned</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-[#15151F]">
        <div className="w-full max-w-sm" data-testid={testid}>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-300 mb-3">{kicker}</div>
          <h1 data-testid="auth-title" className="font-display text-3xl font-extrabold tracking-tight mb-1">{title}</h1>
          {sub && <p className="text-zinc-500 text-sm mb-8">{sub}</p>}
          {children}
          <div className="mt-4 text-[11px]"><Link to="/" className="text-zinc-500 hover:text-zinc-300">← Back to cyboscan.com</Link></div>
        </div>
      </div>
    </div>
  );
}
